import { API_URL } from '../../constants';

export const PAGINATION_PER_PAGE = 20;
export const PROJECTS_API_PATH = `${API_URL}/projects`;
export const API_MODEL_TYPE_PROJECT = 'project';
